<template>
  <div style="height: 100%; overflow: auto">
    <h5><a v-bind:href="'https://cdli.ucla.edu/search/archival_view.php?ObjectID='+cdli_no"  target="_blank">{{ cdli_no }}</a></h5>
    <p class="text-left" v-html="tablet_content"></p>
  </div>
</template>

<script>
  import axios from 'axios'
  
  export default {
    data () {
      return {
        tablet_content: ''
      }
    },

    props: ['cdli_no'],

    watch: {
      cdli_no: function (val) {
        this.tablet_content = '';
        axios.post("http://localhost:8081/cdli", { cdli_no: val })
          .then(response => {
              const matches = response.data.match(/<!-- DATA PART -->([\s\S]*)<!-- IMAGE PART -->[\s\S]*<!-- TRANSLITERATION PART -->([\s\S]*)<!-- REVISION HISTORY PART -->/);
              this.tablet_content = matches[2].replace('<b>Tablet</b><br>', '').replace('<br><i>', '<i>');
            })
          .catch(e => {console.log(e)})
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/CDLIView.vue